import * as XLSX from 'xlsx';

/**
 * Export data to Excel file
 * @param {Array} data - Array of objects to export
 * @param {String} filename - Name of the Excel file
 * @param {String} sheetName - Name of the worksheet
 */
export const exportToExcel = (data, filename, sheetName = 'Sheet1') => {
  // Create a new workbook
  const wb = XLSX.utils.book_new();
  
  // Convert data to worksheet
  const ws = XLSX.utils.json_to_sheet(data);
  
  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  
  // Export the workbook
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

/**
 * Export multiple tables to Excel file with multiple sheets
 * @param {Array} tables - Array of table objects with data, sheetName properties
 * @param {String} filename - Name of the Excel file
 */
export const exportMultipleToExcel = (tables, filename) => {
  // Create a new workbook
  const wb = XLSX.utils.book_new();
  
  // Add each table as a separate sheet
  tables.forEach(table => {
    const ws = XLSX.utils.json_to_sheet(table.data);
    XLSX.utils.book_append_sheet(wb, ws, table.sheetName);
  });
  
  // Export the workbook
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

export default { exportToExcel, exportMultipleToExcel };